import { Alert, Stack, Typography } from "@mui/material";
import { AlertProps } from "@mui/material/Alert";
import { Trans, useTranslation } from "react-i18next";

import { GqlUser } from "~/__generated__";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDateTime } from "~/modules/app/util/formatters";
import UserBadge from "~/modules/user/components/UserBadge";

type IsRejectedAlertProps = {
    actor: Pick<GqlUser, "firstName" | "lastName"> & { profilePictureMedia?: { url?: string | null } | null };
    color?: AlertProps["color"];
    date: string;
    reason?: string;
    variant: "deleted" | "rejected";
};

export function IsRejectedAlert({ actor, color, date, reason, variant }: IsRejectedAlertProps) {
    const { t } = useTranslation("shared");

    return (
        <Alert color={color} icon={false} sx={{ paddingInline: 2 }}>
            <Stack rowGap={2}>
                <Stack columnGap={0.5} direction="row" flexWrap="wrap" alignItems="center">
                    <Trans
                        t={t}
                        i18nKey={`IsRejectedAlert.${variant}.actorOnDate`}
                        values={{ date: formatDateTime(parseStringToDate(date)) }}
                        components={{
                            avatar: (
                                <UserBadge
                                    names={[actor.firstName, actor.lastName]}
                                    profilePicture={actor.profilePictureMedia?.url}
                                    size={25}
                                    showName
                                    nameTextVariant="body2"
                                />
                            ),
                        }}
                    />
                </Stack>
                {reason !== undefined && (
                    <Stack>
                        <Typography variant="caption">{t(`IsRejectedAlert.${variant}.reason`)}</Typography>
                        <Typography>{reason}</Typography>
                    </Stack>
                )}
            </Stack>
        </Alert>
    );
}
